import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IToastInputs } from './nv-toast.component.interface';

@Component({
  selector: 'nv-toast',
  template: require('./nv-toast.component.html'),
  styles: [require('./nv-toast.component.scss')],
})
export class NvToastComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<NvToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: IToastInputs,
  ) {}
}
